import { Button } from '@/components/shadcn/button'
import {
  IconCirclePlusOutline,
  IconCollapseChevronOutline,
  IconExpandChevronOutline,
  IconRedoOutline,
} from '@/components/icons'
import { TooltipWrapper } from '@/components/ui/TooltipWrapper'
import { ComposedSheet } from '@/components/ui/ComposedSheet'
import { MenuItemForm } from './MenuItemForm'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { MessagesLandingMenuItem } from './types'

interface MenuToolbarProps {
  isExpanded: boolean
  hasChanged: boolean
  toggleExpandCollapse: () => void
  addRootItem: (newItem: MessagesLandingMenuItem) => void
  handleSave: () => void
  resetMenuItems: () => void
}

export function MenuToolbar({
  isExpanded,
  hasChanged,
  toggleExpandCollapse,
  addRootItem,
  handleSave,
  resetMenuItems,
}: MenuToolbarProps) {
  return (
    <div className="mb-4 flex space-x-2">
      <TooltipButton tooltip={isExpanded ? 'Collapse all' : 'Expand all'}>
        <Button variant="outline" size="icon" onClick={toggleExpandCollapse}>
          {isExpanded ? <IconCollapseChevronOutline size={14} /> : <IconExpandChevronOutline size={14} />}
          <span className="sr-only">{isExpanded ? 'Collapse all' : 'Expand all'}</span>
        </Button>
      </TooltipButton>
      <div className="flex-grow"></div>
      <TooltipWrapper
        tooltip="Add a new top-level menu item"
        wrapTrigger
        triggerComponent={
          <ComposedSheet trigger={undefined} title="New menu item">
            <MenuItemForm
              showIcon={true}
              closeSheetOnSubmit
              onSubmit={(data) => {
                const formData = data as Record<string, unknown>
                const menuItem: MessagesLandingMenuItem = {
                  item_type: String(formData.item_type || ''),
                  name: String(formData.name || ''),
                  page_id: String(formData.page_id || ''),
                  description: String(formData.description || ''),
                  icon_name: formData.icon_name ? String(formData.icon_name) : undefined,
                  roles: (formData.assignedRoles as string[]) ?? [],
                  items: [],
                }
                addRootItem(menuItem)
              }}
              initialValues={{ name: '', roles: [], page_id: '', item_type: '', description: '' }}
            />
          </ComposedSheet>
        }
      >
        <Button variant="outline">
          <IconCirclePlusOutline className="mr-2 size-4" />
          Add menu item
        </Button>
      </TooltipWrapper>
      <Button className="relative overflow-visible" disabled={!hasChanged} onClick={() => handleSave()}>
        Save menu
        {hasChanged && (
          <div className="pointer-events-none absolute inset-[10%] size-[80%] animate-ping rounded-lg border border-primary opacity-50"></div>
        )}
      </Button>
      <TooltipButton tooltip="Undo all changes">
        <Button variant="outline" size="icon" disabled={!hasChanged} onClick={resetMenuItems}>
          <IconRedoOutline size={24} />
        </Button>
      </TooltipButton>
    </div>
  )
}
